import React from 'react';
import './StakeModal.css';

const StakeModal = ({ requiredStake, onClose, onGetTokens }) => {
  return (
    <div className="stake-modal-overlay">
      <div className="stake-modal">
        <div className="stake-modal-header">
          <h2>🪙 Stake Required</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        
        <div className="stake-modal-content">
          <div className="stake-requirement">
            <div className="stake-icon">💰</div>
            <h3>Token Stake Required</h3>
            <p>You need to stake <strong>{requiredStake.toLocaleString()} ZNOOZINU tokens</strong> to create posts.</p>
          </div>
          
          <div className="stake-benefits">
            <h4>Why Staking?</h4>
            <ul>
              <li>🛡️ Prevents spam and low-quality content</li>
              <li>🏆 Builds reputation in the community</li>
              <li>🗳️ Enables DAO voting privileges</li>
              <li>✨ Unlocks premium features</li>
            </ul>
          </div>
          
          <div className="stake-actions">
            <button 
              className="get-tokens-btn"
              onClick={onGetTokens}
            >
              Get ZNOOZINU Tokens
            </button>
            <button 
              className="cancel-btn"
              onClick={onClose}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StakeModal;
